import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import VueCompositionApi from "@vue/composition-api"
import ElementUI from "element-ui"
import './style/theme/index.css'
import 'windi.css'
import common from './common'


Vue.config.productionTip = false

Vue.use(common)
Vue.use(VueCompositionApi)
Vue.use(ElementUI)


let lang = 'zh_CN';
let rs = window.location.href.match(/([^=^&]+)=([^=^&]*)/ig);
let maptype = window.localStorage.maptype || 'gmap';
let ele = document.getElementsByClassName("sys-map-type")[0];
if (ele && ele.getAttribute("type")) {
	maptype = ele.getAttribute("type")
}
if (rs && rs.length > 1) {
	for (let i = 1; i < rs.length; ++i) {
		let s = rs[i].split('=')
		let k = s[0]
		let v = s[1]
		if (k === 'maptype') {
			maptype = v;
		}
	}
}
if (maptype && maptype != window.localStorage.maptype) {
	window.localStorage.maptype = maptype;
}
if (maptype === "bmap") {
	document.write(
		'<script type="text/javascript" src="https://api.map.baidu.com/api?v=2.0&ak=l1Arh4IsfY3cwZOeFsTmewm71330U5mZ"></script>'
	);
} else if (maptype === "gmap") {
	document.write(
		'<script type="text/javascript" src="https://maps.googleapis.com/maps/api/js?key=AIzaSyBMF3FGOPdw3yFDICI7ojIU147CjtRZOhc&libraries=places&language=' +
		lang + '"></script>');
}
// #endif



new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app")
